import {apiRequest} from "../helpers/utils";

export const automationRulesServices = {
    read,
    find,
    remove,
    create,
    update,
    readActionLogs
};

function readActionLogs({ruleId, executionId, page = 1, limit = 25}) {
    return apiRequest('get', 'v1/automation/logs', {}, {
        ruleId, page, limit, ...(executionId ? {executionId} : {})
    });
}

function read({page, orderBy, sortBy, workspace}) {
    let params = {
        page,
        orderBy,
        sortBy,
        workspace,
        pageSize: 100
    };
    return apiRequest("get", "v1/automation/rule", {}, params);
}

function find(id) {
    return apiRequest("get", "v1/automation/rule/" + parseInt(id));
}

function create(formData) {
    return apiRequest("post", "v1/automation/rule", formData);
}

function update({id, formData}) {
    return apiRequest("put", "v1/automation/rule/" + parseInt(id), formData);
}

function remove({ruleId}) {
    return apiRequest("delete", "v1/automation/rule/" + parseInt(ruleId), {});
}
